Vue.component('cookiescript-declaration-component', {
    name: 'CookiescriptDeclarationComponent',
    props: {
        domainId: {
            type: String,
            required: true
        }
    },
    mounted() {
        this.init()
    },
    methods: {
        init(){
            // Load external js
            const script = document.createElement('script');
            script.src = '//report.cookie-script.com/r/'+this.domainId+'.js';
            script.setAttribute('data-cookiescriptreport', 'report')
            document.getElementById('CookieDeclaration').appendChild(script);
            this.$root.cookiebotDeclarationLoaded = true
        },
        cleanup() {
            this.$refs.target.querySelector('style').remove();

            Array.from(this.$refs.target.querySelectorAll('table:not(:has(tbody > tr))')).forEach(table => {
                table.previousElementSibling.remove();
                table.remove();
            });

            Array.from(this.$refs.target.querySelectorAll('button')).forEach(button => {
                button.classList.add('button', 'button--primary');
            });
        }
    }
});
